import React from 'react'

import Icon, { EIconId } from '../../../../components/icons'

import PaypalLogo from '../../../../assets/paypal-logo.png'
import PackstationLogo from '../../../../assets/packstation-logo.png'
import SchweizerischePostLogo from '../../../../assets/schweizerische-post-logo.png'
import DhlLogo from '../../../../assets/dhl-logo.png'

import { items } from '../LegalArea/data'

import ELocale from '../../../../types/locales'
import { TItem } from '../../types'

enum ESectionType {
  SERVICE = 'service',
  PAYMENT = 'payment',
  LEGAL = 'legal',
  PARTNER = 'partner',
  ABOUT = 'about',
  TV = 'tv',
  INTERNATIONAL = 'international',
  SHIPPING = 'shipping',
  FOLLOW = 'follow',
}

type TSection = {
  id: ESectionType
  title: string
  className?: string
  items: TItem[]
}

const mainSections: TSection[] = [
  {
    id: ESectionType.SERVICE,
    title: 'Service & Beratung',
    items: [
      {
        label: 'Service & Hilfe',
        url: '/dpl/c/service/uebersicht',
      },
      {
        label: 'Tipps & Beratung',
        url: '/dpl/c/ratgeber',
      },
      {
        label: 'Neukundeninformationen',
        url: '/dpl/c/service/neukundengutschein',
      },
      {
        label: 'Rücknahme Elektro- und Elektronikgeräte',
        url: '/dpl/c/service/ruecknahme-elektro-und-elektronikgeraete',
      },
    ],
  },
  {
    id: ESectionType.PAYMENT,
    title: 'Zahlung',
    items: [
      {
        label: 'Ratenzahlung',
        url: '/dpl/c/service/bezahlung',
        hideIn: [ELocale.DE_AT, ELocale.DE_CH],
      },
      {
        label: 'Lastschrift',
        url: '/dpl/c/service/bezahlung',
        hideIn: [ELocale.DE_AT, ELocale.DE_CH],
      },
      {
        label: 'Rechnung',
        url: '/dpl/c/service/bezahlung',
      },
      {
        label: 'PayPal',
        url: '/dpl/c/service/bezahlung',
        image: PaypalLogo,
        hideIn: [ELocale.DE_CH],
      },
      {
        label: 'Nachnahme',
        url: '/dpl/c/service/bezahlung',
        hideIn: [ELocale.DE_AT, ELocale.DE_DE],
      },
    ],
  },
  {
    id: ESectionType.LEGAL,
    title: 'Rechtliches',
    items: [
      {
        label: 'Beschwerde/Streitschlichtung',
        url: '/dpl/c/service/streitschlichtung',
      },
      {
        ...items[0],
        label: 'Widerrufsbelehrung',
      },
      {
        ...items[1],
        label: 'Sicherheit',
      },
    ],
  },
  {
    id: ESectionType.PARTNER,
    title: 'Partner',
    items: [
      {
        label: 'küchenquelle',
        url: '/dpl/c/kuechenquelle',
      },
      {
        label: 'Partnerprogramm',
        url: '/dpl/c/service/partnerprogramm',
      },
      {
        label: 'Lieferanten',
        url: 'https://corporate.hse.com/de/supplier/startseite/',
      },
    ],
  },
  {
    id: ESectionType.ABOUT,
    title: 'Über HSE',
    items: [
      {
        label: 'Unternehmen',
        url: 'https://corporate.hse.com/',
      },
      {
        label: 'Empfangswege',
        url: '/dpl/c/service/empfangbarkeit',
      },
      {
        label: 'Karriere',
        url: 'http://jobs.hse.com/',
      },
      {
        label: 'Newsroom',
        url: 'https://corporate.hse.com/',
      },
    ],
  },
  {
    id: ESectionType.TV,
    title: 'Im TV',
    items: [
      {
        label: 'HSE',
        url: '/dpl/c/live-im-tv',
      },
      {
        label: 'HSE Extra',
        url: '/dpl/c/live-im-tv/hse-extra',
      },
      {
        label: 'HSE Trend',
        url: '/dpl/c/live-im-tv/hse-trend',
      },
    ],
  },
  {
    id: ESectionType.INTERNATIONAL,
    title: 'HSE International',
    items: [
      {
        label: 'Deutschland',
        url: 'https://www.hse.de/',
      },
      {
        label: 'Schweiz',
        url: 'https://www.hse24.ch/',
      },
      {
        label: 'Österreich',
        url: 'https://www.hse.at/dpl/c/home',
      },
      {
        label: 'Russland',
        url: 'https://www.shoppinglive.ru/',
      },
    ],
  },
]

const metaSections: TSection[] = [
  {
    id: ESectionType.FOLLOW,
    title: 'Folge uns',
    className: 'sm:order-2',
    items: [
      {
        label: 'YouTube',
        url: 'https://www.youtube.com/c/hseDE',
        icon: <Icon id={EIconId.YOUTUBE} className="w-32" />,
      },
      {
        label: 'Facebook',
        url: 'https://www.facebook.com/hse.de',
        icon: <Icon id={EIconId.FACEBOOK} className="w-32" />,
      },
      {
        label: 'Instagram',
        url: 'https://www.instagram.com/hse.de',
        icon: <Icon id={EIconId.INSTAGRAM} className="w-32" />,
      },
      {
        label: 'WhatsApp',
        url: 'http://bit.ly/hse-whatsapp',
        icon: <Icon id={EIconId.WHATSAPP} className="w-32" />,
      },
    ],
  },
  {
    id: ESectionType.SHIPPING,
    title: 'Versand durch',
    className: 'sm:order-1',
    items: [
      {
        label: 'DHL',
        url: '/help/lieferung.html',
        image: DhlLogo,
        hideIn: [ELocale.DE_CH],
      },
      {
        label: 'DHL Packstation',
        url: '/dpl/c/service/lieferung',
        image: PackstationLogo,
        hideIn: [ELocale.DE_CH],
      },
      {
        label: 'Schweizer Post',
        url: '/dpl/c/service/lieferung',
        image: SchweizerischePostLogo,
        hideIn: [ELocale.DE_AT, ELocale.DE_DE],
      },
    ],
  },
]

export { mainSections, metaSections, TSection, ESectionType }
